import { render, staticRenderFns } from "./centerChannelsEdit.vue?vue&type=template&id=7ce906df&scoped=true"
import script from "./centerChannelsEdit.vue?vue&type=script&lang=js"
export * from "./centerChannelsEdit.vue?vue&type=script&lang=js"
import style0 from "./centerChannelsEdit.vue?vue&type=style&index=0&id=7ce906df&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce906df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce906df')) {
      api.createRecord('7ce906df', component.options)
    } else {
      api.reload('7ce906df', component.options)
    }
    module.hot.accept("./centerChannelsEdit.vue?vue&type=template&id=7ce906df&scoped=true", function () {
      api.rerender('7ce906df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelsmanage/centerChannelsEdit.vue"
export default component.exports